﻿import { mutations } from "@/graphql";
import { useContext, useState } from "react";
import { useMutation } from "@apollo/client/react";
import { useSnackbar } from "notistack";
import { useTextDomainContext } from "../../app/providers";
export const useAddUserToTenant = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const { enqueueSnackbar } = useSnackbar();
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [addUserToTenant, { loading, data }] = useMutation<any>(
    mutations.addUserToTenant,
    {
      onCompleted: (response) => {
        if (response?.addUserToTenant?.success) {
          enqueueSnackbar(gettext("The user has been linked."), {
            variant: "success",
          });
          setResetForm(true);
        } else {
          let message = gettext("The user already linked.");
          if (Array.isArray(response?.addUserToTenant?.message)) {
            if (
              response?.addUserToTenant?.message[0] !==
              "User already exists in tenant!"
            ) {
              message = response?.addUserToTenant?.message[0];
            }
          } else if (typeof response?.addUserToTenant?.message === "string") {
            if (
              response?.addUserToTenant?.message !==
              "User already exists in tenant!"
            ) {
              message = response?.addUserToTenant?.message;
            }
          }
          enqueueSnackbar(message, {
            variant: "error",
          });
        }
        setSuccess(response?.addUserToTenant?.success);
        // setTimeout(() => {
        //   setSuccess(false);
        //   setResetForm(false);
        // }, 5000);
        onCompleted();
      },
      onError: ({ message }) => {
        setSuccess(false);
        onError(message);
        enqueueSnackbar(message, {
          variant: "error",
        });
      },
      refetchQueries: ["TenantsUsersList", "TenantsList"],
    },
  );

  return {
    addUserToTenant,
    loading,
    success,
    data,
    resetForm,
  };
};
